import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import loadable from '@loadable/component'

import SanityResponsiveImage from '../SanityResponsiveImage'

const Button = loadable(() => import('../Button'))

const CardLink = ({ content, className }) => {
  let { link } = content

  if (link) {
    if (!link.endsWith('/')) {
      link = `${link}/`
    }
  }

  return (
    <Link
      to={link}
      className={`bg-white rounded-lg overflow-hidden shadow-sm transition-shadow duration-300 transform hover:shadow-md relative h-350px md:h-390px ${className}`}
    >
      <div className="absolute inset-0 bg-black">
        <SanityResponsiveImage
          image={content.bgImg}
          className="object-cover w-full h-full opacity-75"
          alt={content.title}
          width={650}
          height={390}
          widths={[320, 500, 650]}
          sizes="(min-width: 768px) 50vw, 100vw"
        />
      </div>
      <div className="absolute inset-0 z-20 flex flex-col items-start justify-end p-8">
        <h2 className="text-gray-200 text-24 md:text-30 tracking-subtitle font-bold mb-3">
          {content.title}
        </h2>
        <div className="truncate-last-line overflow-hidden break-normal h-55px md:h-67px leading-snug mb-4 text-14 md:text-16 text-gray-200">
          {/* <p>{content.description[0].children[0].text}</p> */}
        </div>
        <Button colour="white" psuedo>
          {content.buttonText}
        </Button>
      </div>
    </Link>
  )
}

CardLink.propTypes = {
  content: PropTypes.object,
  className: PropTypes.string,
}

CardLink.defaultProps = {
  content: {},
  className: '',
}

export default CardLink
